import { CaseLabelsSearchRequest } from '@trukt/tms-api/CaseService';
import { createKey } from './createKey';

const keyHandler = createKey('case');

export const CaseServiceKeys = {
  key: keyHandler.key,
  searchLabels: keyHandler.createMethod<CaseLabelsSearchRequest>(),
};
